import React, { useContext } from "react";
import { Anchor, Box, Footer, ResponsiveContext, Stack, Text } from "grommet";
import mountainPic from "../assets/mountain.jpg";
import colors from "../colors";


const AppFooter = () => {
  const viewportSize = useContext(ResponsiveContext);
  return (
    <>
      <Footer
        background={{ image: "url(" + mountainPic + ")" }}

        // direction="column"
      >
        <Stack anchor="bottom-left" fill>
          <Box direction="column" align="center" gap="medium" pad={{top:"large", bottom:viewportSize === "small" ? "70px" : "large"}}>
            <TextBox>Aitapissko Counseling Collective PLLC</TextBox>
            <TextBox>5767 Harrier Dr., Suite 201, Missoula, MT 59808</TextBox>
            <TextBox>email: admin@aitapisskocounseling.com</TextBox>
            <TextBox>phone: 406-298-2970</TextBox>
          </Box>
          <Box pad={"small"}>
            <Anchor
              href="https://www.bbb.org/us/mt/missoula/profile/counseling/aitapissko-counseling-collective-llc-1296-1000177954/#sealclick"
              target="_blank"
              rel="nofollow"
            >
              <img
                src="https://seal-alaskaoregonwesternwashington.bbb.org/seals/blue-seal-250-52-whitetxt-bbb-1000177954.png"
                style={{ border: 0 }}
                alt="Aitapissko Counseling Collective PLLC BBB Business Review"
              />
            </Anchor>
          </Box>
        </Stack>
      </Footer>
      <Footer
        background={{ color: colors.dark, opacity: "medium" }}
        pad={{ horizontal: "medium", vertical: "xsmall" }}
        title="Copyright"
        role="none"
      >

        <Text textAlign="center" size="small" color={colors.dark}>
          ©2025 Copyright
        </Text>
      </Footer>
    </>
  );
};

const TextBox = ({ children }) => {
  return (
    <Box>
      <Text size="small" style={{ textShadow: "white 1px 0 10px" }}>
        <strong>{children}</strong>{" "}
      </Text>
    </Box>
  );
};
export default AppFooter;
